import { Form, Formik } from "formik";
import { useEffect, useRef, useState, useCallback } from "react";
import { useNavigate, useParams } from "react-router";

import { getApi, putApi } from "../../services/api/globalApi";
import {
  errorMessage,
  successMessage,
} from "../../utils/toastify-message/ToastifyMessage";

import Button from "../../components/common/button/Button";
import Input from "../../components/common/inputs/Input";
import Title from "../../components/common/title/Title";
import Select from "../../components/common/inputs/Select";
import CurrencyInput from "../../components/common/inputs/CurrencyInput";
import { depositValidation } from "../../utils/validations/depositValidation";

export default function EditTransaction() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [transaction, setTransaction] = useState(null);
  const [loading, setLoading] = useState(true);
  const amountRef = useRef();

  const getTransactionData = useCallback(async () => {
    try {
      const path = `admin/wallets/${id}`;
      const response = await getApi({ path });
      setTransaction(response?.data?.result);
      setLoading(false);
    } catch (error) {
      console.error(error);
      errorMessage("خطا در دریافت اطلاعات تراکنش");
      navigate("/wallets-transaction");
    }
  }, [id, navigate]);

  useEffect(() => {
    getTransactionData();
  }, [getTransactionData]);

  const formHandler = async (values) => {
    const body = {
      amount: Number(values.amount),
      description: values.description,
      isCommission: values.isCommission === "true",
    };

    try {
      const path = `admin/wallets/${id}`;
      await putApi({ path, body: JSON.stringify(body) });
      successMessage("تراکنش با موفقیت ویرایش شد");
      navigate("/wallets-transaction");
    } catch (error) {
      console.error(error);
      errorMessage(error?.response?.data?.errors[0]?.message);
    }
  };

  if (loading) {
    return (
      <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
        <div className="flex justify-center items-center h-64">
          <p className="text-gray-500 dark:text-gray-400">در حال بارگذاری...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <Title title={`ویرایش تراکنش ${transaction?.trackingCode}`} />
      <Formik
        enableReinitialize
        initialValues={{
          amount: transaction?.amount || "",
          isCommission: transaction?.isCommission ? "true" : "false",
          description: transaction?.description || "",
        }}
        validationSchema={depositValidation}
        onSubmit={formHandler}
      >
        {(formik) => (
          <Form>
            <div className="mt-6">
              <div className="grid gap-6 mb-4 md:grid-cols-2">
                <div>
                  <label className="block mb-4 text-sm font-medium text-gray-900 dark:text-white">
                    نوع تراکنش
                  </label>
                  <input
                    value={transaction?.type === "deposit" ? "واریز" : "برداشت"}
                    disabled
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  />
                </div>
                <div>
                  <label className="block mb-4 text-sm font-medium text-gray-900 dark:text-white">
                    انتخاب کاربر
                  </label>
                  <input
                    value={transaction?.user?.name || "-"}
                    disabled
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  />
                </div>
                <div>
                  <label
                    htmlFor="large-input"
                    className="backdrop-blur block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    مبلغ
                  </label>
                  <CurrencyInput
                    placeholder="مبلغ"
                    ref={amountRef}
                    name="amount"
                    inputValue={formik.values["amount"]}
                    onChange={(e) => formik.setFieldValue("amount", e)}
                  />
                  {formik.errors.amount && formik.touched.amount ? (
                    <p className="text-sm my-4 text-red-500">
                      {formik.errors.amount}
                    </p>
                  ) : null}
                </div>

                <Select
                  name="isCommission"
                  placeholder="کمیسیونه ؟"
                  label="کمیسیونه ؟"
                >
                  <option value="true">بله</option>
                  <option value="false">خیر</option>
                </Select>

                <Input
                  name="description"
                  placeholder="توضیحات"
                  label="توضیحات"
                  type="text"
                />
              </div>
              <div className="flex flex-col gap-y-2">
                <div className="flex items-center gap-2 mt-6">
                  <Button text="ویرایش" color="success" />
                  <Button
                    text="بازگشت"
                    color="gray"
                    type="button"
                    onClick={() => navigate("/wallets-transaction")}
                  />
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}
